import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

// Tus imports de componentes
import Nosotros from "./components/Nosotros";
import Inicio from "./components/Inicio";
import Producto from "./components/Producto";
import Contacto from "./components/Contacto";
import Servicios from "./components/Servicios";
import Tuberia_redonda from "./components/Tuberia_redonda";
import Tuberia_cedulas from "./components/Tuberia_cedulas";
import Tuberia_cerquero from "./components/Tuberia_cerquero";
import Tuberia_cuadrada from "./components/Tuberia_cuadrada";
import Ptr from "./components/Ptr";
import Perfil_Puerta from "./components/Perfil_Puerta";
import Perfil_Ventana from "./components/Perfil_Ventana";
import Lamina_R101 from "./components/Lamina_R101";
import Angulos from "./components/Angulos";
import Tubos from "./components/Tubos";
import Ptr_Perfiles from "./components/Ptr_Perfiles";
import Ptr_tub_cuadradas from "./components/Ptr_tub_cuadradas";
import Perfiles from "./components/Perfiles";
import Laminas from "./components/Láminas";
import Aviso_Privacidad from "./components/Aviso_Privacidad";
import Terminos from "./components/Terminos";
import InicioAceros from "./components/InicioAceros";
import Mobiliario from "./components/Mobiliario";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<InicioAceros />} />
        <Route path="/mobiliario" element={<Mobiliario />} />
        <Route path="/aceros" element={<Inicio />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/productos" element={<Producto />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/servicio" element={<Servicios />} />
        <Route path="/tuberia-redonda" element={<Tuberia_redonda />} />
        <Route path="/tuberia-cedulas" element={<Tuberia_cedulas />} />
        <Route path="/tubo-cerquero" element={<Tuberia_cerquero />} />
        <Route path="/tuberia-cuadrada" element={<Tuberia_cuadrada />} />
        <Route path="/ptr" element={<Ptr />} />
        <Route path="/perfil-puerta" element={<Perfil_Puerta />} />
        <Route path="/perfil-ventana" element={<Perfil_Ventana />} />
        <Route path="/lamina-R-101" element={<Lamina_R101 />} />
        <Route path="/angulos-soleras" element={<Angulos />} />
        <Route path="/tuberia" element={<Tubos />} />
        <Route path="/ptr-perfiles" element={<Ptr_Perfiles />} />
        <Route path="/ptr-tuberia-cuadrada" element={<Ptr_tub_cuadradas />} />
        <Route path="/perfiles" element={<Perfiles />} />
        <Route path="/laminas" element={<Laminas />} />
        <Route path="/Avisos_Privacidad" element={<Aviso_Privacidad />} />
        <Route path="/Terminos_y_Condiciones" element={<Terminos />} />

      </Routes>
    </Router>
  );
};

export default App;
